<!-- Preloader -->
<div class="preloader">
  <div class="row d-flex justify-content-center align-items-center" style="height:100vh">
    <div class="text-center"><img src="{{cs.apiUrl}}media/Transparent_DIS_10 Years Logo.png" alt="DIS 10 years logo" style="height:180px">
      <div class="spinner"><img src="../../../../assets/DISLOGO.svg" alt="DIS logo" style="width:200px;height:200px;"></div>

    </div>
  </div>
  <!-- End Preloader -->
